const getBookJsonById = async (bookId) => {
  return fetch(`${process.env.REACT_APP_BOOKS_CDN_DOMAIN}/${bookId}/book.json`).then((res) => res.json());
};

export const fetchBook = async (bookId) => await getBookJsonById(bookId);
export const fetchBooksHandler = async (bookIds) => Promise.all(bookIds.map(fetchBook));